import React from "react";

const ASP_Looping = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Looping</h1>
      <p>This is the ASP Looping page content.</p>
    </div>
  );
};

export default ASP_Looping;
